export function dailyrentPublicOfferReducer(state: boolean = false): boolean {
  return state;
}
